import { useAuth } from '../../../auth/auth-context'
import useFetch from '../../../_fetch'
import { getColumns } from './columns'
import { Table } from '../_table/table'

export default function TransactionReport() {
    const {user} = useAuth()
    const { doFetch } = useFetch()
    const isPublisher = user?.kind === 'publisher'
    const columns = getColumns(isPublisher)
    
  return (
    <Table 
        columns={columns} 
        getData={async (fromDate, toDate) => {
            const res = await doFetch('/data/get-transactions', {
                fromDate, toDate, timezoneOffsetMinutes: new Date().getTimezoneOffset()
            })
            if (!res.ok) throw new Error('Transactions could not be fetched for the selected period.')

            const data = await res.json()
            if (!Array.isArray(data)) throw new Error('The server returned an unexpected transaction report format.')

            return data
        }}
        title='Transaction Report'
        description='Review individual conversions, their status, value, commission, and attribution details.'
        entityLabel='transactions'
        pageKey='transaction-report'
        defaultSort='date'
    />)
}
